import { render, staticRenderFns } from "./DraftOfferVerification.vue?vue&type=template&id=53176d4a&"
import script from "./DraftOfferVerification.vue?vue&type=script&lang=js&"
export * from "./DraftOfferVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports